import styled from 'styled-components';

export const SearchInputLayout = styled.div`
  height: 100%;
  padding: 8px 16px;
  background: white;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 8px;

  input {
    flex: 1;
    border: none;
    outline: none;
    color: #74788d;
    font-size: 14px;
    font-family: Poppins;
    font-weight: 500;

    &::placeholder {
      color: #74788d;
    }
  }

  i {
    font-size: 16px;
    color: #484848;
  }
`;
